import React from 'react';

import { getLink } from '../../utils';

export default function Header() {
  return (
    <div className="header-container">
      <div className="smls-home-header">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <a
            onClick={() => {
              window.location.href = getLink('home');
            }}
          >
            <span className="smls-logos smiles">
              <b>Smiles</b>
            </span>
          </a>
          <div
            className="close-button"
            onClick={() => {
              window.location.href = getLink('home');
            }}
          >
            <i className="material-icons">close</i>
          </div>
        </div>
      </div>
    </div>
  );
}
